"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title1: {
        id: 'authTemplates.resetPassword.title1',
        defaultMessage: 'Reset password',
        description: 'Reset password first title',
    },
    title2: {
        id: 'authTemplates.resetPassword.title2',
        defaultMessage: 'Verify your email',
        description: 'Reset password second title',
    },
    title3: {
        id: 'authTemplates.resetPassword.title3',
        defaultMessage: 'Password Changed',
        description: 'Password changed title',
    },
    title4: {
        id: 'authTemplates.resetPassword.title4',
        defaultMessage: 'Change Password',
        description: 'Change password title',
    },
    passwordChangedMsg: {
        id: 'authTemplates.resetPassword.passwordChanged.message',
        defaultMessage: 'Your password has been successfully reset.',
        description: 'Password changed message',
    },
    criteriaTitle: {
        id: 'authTemplates.resetPassword.criteria.title',
        defaultMessage: 'The password should match the following criteria:',
        description: 'Reset password criteria ',
    },
    criteriaItem1: {
        id: 'authTemplates.resetPassword.criteria.item.1',
        defaultMessage: 'contains between 8 and 20 characters',
        description: 'Reset password criteria item 1',
    },
    criteriaItem2: {
        id: 'authTemplates.resetPassword.criteria.item.2',
        defaultMessage: 'contains both lower case letters (a‑z) and upper case letters (A‑Z)',
        description: 'Reset password criteria item 2, IMPORTANT: use non-breaking hyphens!',
    },
    criteriaItem3: {
        id: 'authTemplates.resetPassword.criteria.item.3',
        defaultMessage: 'contains at least one digit (0‑9)',
        description: 'Reset password criteria item 3, IMPORTANT: use non-breaking hyphen!',
    },
    criteriaItem4: {
        id: 'authTemplates.resetPassword.criteria.item.4',
        defaultMessage: 'contains at least one special character (!, @, #, $, %, ...)',
        description: 'Reset password criteria item 4',
    },
    passwordPlaceholder: {
        id: 'authTemplates.resetPassword.password.placeholder',
        defaultMessage: 'Enter new password',
        description: 'Reset password new password placeholder',
    },
    confirmPasswordPlaceholder: {
        id: 'authTemplates.resetPassword.confirmPassword.placeholder',
        defaultMessage: 'Confirm new password',
        description: 'Reset password confirm password placeholder',
    },
    resendCodeDescription: {
        id: 'authTemplates.resetPassword.resendCode.description',
        defaultMessage: 'Didn’t receive the email?',
        description: 'Reset password resend code description',
    },
    resendCodeLabel: {
        id: 'authTemplates.resetPassword.resendCode.label',
        defaultMessage: 'Send new code',
        description: 'Reset password resend code label',
    },
    changePassword: {
        id: 'authTemplates.resetPassword.password.cta',
        defaultMessage: 'Change password',
        description: 'Reset password set password CTA button label',
    },
    backToLogin: {
        id: 'authTemplates.resetPassword.backToLogin',
        defaultMessage: 'Back to login',
        description: 'Reset password back to login button label',
    },
    oldPasswordLabel: {
        id: 'authTemplates.resetPassword.oldPassword.label',
        defaultMessage: 'Old password',
        description: 'Change password, old password, label',
    },
    oldPasswordPlaceholder: {
        id: 'authTemplates.resetPassword.oldPassword.placeholder',
        defaultMessage: 'Enter old password',
        description: 'Change password, old password, placeholder',
    },
    newPasswordLabel: {
        id: 'authTemplates.resetPassword.newPassword.label',
        defaultMessage: 'New password',
        description: 'Change password, new password, label',
    },
    confirmPasswordLabel: {
        id: 'authTemplates.resetPassword.confirmPassword.label',
        defaultMessage: 'Confirm new password',
        description: 'Change password, confirm password, label',
    },
    verificationCodeSent: {
        id: 'authTemplates.resetPassword.verificationCode.sent',
        defaultMessage: 'Verification code has been sent. Please copy it to the input box below.',
        description: 'Reset password, verification sent message',
    },
    sendVerificationCode: {
        id: 'authTemplates.resetPassword.verificationCode.send',
        defaultMessage: 'Send verification code',
        description: 'Reset password, send verification code button label',
    },
    verificationCodeLabel: {
        id: 'authTemplates.resetPassword.verificationCode.label',
        defaultMessage: 'Verification code',
        description: 'Reset password, verification code label',
    },
    verificationCodeVerify: {
        id: 'authTemplates.resetPassword.verificationCode.verify',
        defaultMessage: 'Verify code',
        description: 'Reset password, verify button label',
    },
    proceed: {
        id: 'authTemplates.resetPassword.success.proceedCTA',
        defaultMessage: 'Proceed',
        description: 'Reset password, success screen, CTA to login/welcome page',
    },
});
exports.default = messages;
